import axios from 'axios';
import { toast } from 'sonner';

// Use environment variable, or fallback to current origin for production deploys
// Always ensure HTTPS in production
let apiBaseUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;
if (apiBaseUrl.startsWith('http://') && window.location.protocol === 'https:') {
  apiBaseUrl = apiBaseUrl.replace('http://', 'https://');
}
// Exported for the few call sites that need a raw fetch() instead of this
// axios instance — e.g. SupportChatWidget's SSE stream, which axios doesn't
// read incrementally in the browser.
export const API_BASE_URL = apiBaseUrl;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Guards against every in-flight request 401ing at once (e.g. the token
// expires while several widgets poll in parallel) and each one firing its
// own toast + redirect.
let sessionExpiryHandled = false;

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Limpiar TODO el estado de autenticación
      localStorage.removeItem('authToken');
      localStorage.removeItem('adminToken');
      localStorage.removeItem('impersonatedUser');
      sessionStorage.removeItem('meli_user_cache');
      sessionStorage.removeItem('meli_data_cache');
      sessionStorage.removeItem('shown_login_notifications');

      // Solo redirigir si no estamos ya en login/register
      const currentPath = window.location.pathname;
      const onAuthPage = currentPath === '/login' || currentPath === '/register' || currentPath === '/';

      if (!onAuthPage && !sessionExpiryHandled) {
        sessionExpiryHandled = true;

        // A stale token superseded by a newer login elsewhere (see
        // core/security.py get_current_user's session_version check) looks
        // like a random logout to the user unless we explain it here.
        const detailCode = error.response?.data?.detail?.code;
        if (detailCode === 'session_superseded' || detailCode === 'account_blocked') {
          toast.error(error.response.data.detail.message);
        } else {
          toast.error('Tu sesión expiró. Iniciá sesión nuevamente.');
        }

        // Preserve where the user was so login can send them back.
        const redirectTarget = currentPath + window.location.search;
        window.location.href = `/login?redirect=${encodeURIComponent(redirectTarget)}`;
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;